import {allTopics, lessons as courseLessons} from './trainingCourse';

/**
 * Works out one person's row on the Super Admin training report from their stored progress and the course's own
 * topics and questions, so the report stays right when the course changes (AD-2667).
 */
const parse = progress => {
    try {
        const value = typeof progress === 'string' ? JSON.parse(progress) : progress;

        return value && Array.isArray(value.visited) && value.answers ? value : {visited: [], answers: {}};
    } catch {
        return {visited: [], answers: {}};
    }
};

export const quizLessons = (lessons = courseLessons) => lessons.filter(lesson => (lesson.quiz ?? []).length > 0);

export const summariseProgress = (progress, lessons = courseLessons) => {
    const {visited, answers} = parse(progress);
    const topicIds = lessons.flatMap(lesson => lesson.topics.map(topic => topic.id));
    const opened = new Set(visited.filter(id => topicIds.includes(id)));

    const completedLessons = lessons
        .filter(lesson => lesson.topics.length > 0 && lesson.topics.every(topic => opened.has(topic.id)))
        .map(lesson => lesson.title);

    const scores = {};
    quizLessons(lessons).forEach(lesson => {
        const given = answers[lesson.id] ?? {};

        if (Object.keys(given).length === 0) {
            scores[lesson.title] = 'Not taken';
            return;
        }

        const correct = lesson.quiz.filter((question, index) => Number(given[index]) === question.answer).length;
        scores[lesson.title] = `${correct} of ${lesson.quiz.length}`;
    });

    return {opened: opened.size, total: topicIds.length, completedLessons, scores};
};

const date = value => (value ? new Date(value).toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'}) : '');

const ROLE_NAMES = {SchoolAdmin: 'School Admin', SeniorMemberOfStaff: 'Senior Member of Staff', MemberOfStaff: 'Member of Staff'};

/** The rows the page shows and the file contains, one for each member of staff at each school. */
export const reportRows = (staff = [], lessons = courseLessons) => staff.map(person => {
    const summary = summariseProgress(person.progress, lessons);

    return {
        schoolId: person.schoolId,
        school: person.schoolName,
        firstName: person.firstName,
        lastName: person.lastName,
        email: person.email,
        roles: (person.roles ?? []).map(role => ROLE_NAMES[role] ?? role).join(', '),
        opened: summary.opened,
        topicsOpened: `${summary.opened} of ${summary.total}`,
        lastTopicOpened: date(person.lastTopicOpenedAt),
        lastSignedIn: date(person.lastSignedInAt),
        lessonsCompleted: summary.completedLessons.join(', '),
        scores: summary.scores
    };
});

export const courseTopicCount = () => allTopics.length;
